import React from 'react';

/**
 * Download glyph from the marketing design system: an arrow onto a baseline,
 * 12x12, 1.1 stroke, matching `ArrowDownIcon`. Used on the research pages'
 * CSV download links.
 */
export function DownloadIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 12 12"
      stroke="currentColor"
      strokeWidth="1.1"
      aria-hidden="true"
    >
      <path d="M6 1.5v7M3 5.5l3 3 3-3M2 10.5h8" />
    </svg>
  );
}
